/* ******************************** Import Packages ***************************** */
import React, { useState, useEffect } from "react";
// import { useDispatch } from "react-redux";

/* ******************************** Import Components **************************** */
import SideBar from "./sidebar";
import Content from "./content";

/********************************Import Actions************************************/
// import { profileDropDown } from "../redux/actions";

/* ******************************** Import Constants **************************** */
import {Routes} from "../constants/routes";

/* ******************************** Import Styles ****************************** */
import { LayoutStyled } from "./sidebar/style";
// import { getRolesAndAccessById } from "../api";

const Layout: React.FC = () => {
//   const dispatch = useDispatch();

  const [sidebarMinimize, setSidebarMinimize] = useState(false);
  const [arrow, setArrow] = useState([]);
  const [scrollActive, setScrollActive] = useState("scroll-active") as any;
  const [access, setAccess] = useState();
  const [RouteAccess, setRouteAccess] = useState([]);

  const applyRouteAccess = () => {
    const raw = localStorage.getItem("loggedUser");
    const data: any = raw !== "undefined" ? raw : undefined;
    const { access }: any = data ? JSON.parse(data) : { access: [] };
    setAccess(access);

    if (access?.length > 0) {
      const hasReadAccess = (moduleName: string) =>
        access.some(
          (accessItem: any) =>
            accessItem?.module_name?.toLowerCase() === moduleName?.toLowerCase() &&
            accessItem?.read_access
        );

      const filteredRoutes: any = Routes
        .map((item: any) => {
          const moduleName = item?.requiredAccess || item?.name;
          if (item?.subMenu?.length) {
            if (!hasReadAccess(moduleName)) return null;
            const filteredSubMenu = item.subMenu.filter((subItem: any) =>
              subItem?.requiredAccess ? hasReadAccess(subItem.requiredAccess) : true
            );
            return { ...item, subMenu: filteredSubMenu };
          }
          return hasReadAccess(moduleName) ? item : null;
        })
        .filter(Boolean);
      setRouteAccess(filteredRoutes);
    } else {
      setRouteAccess(Routes as any);
    }
  };

  useEffect(() => {
    applyRouteAccess();
    window.addEventListener("loggedUserUpdated", applyRouteAccess);
    return () => window.removeEventListener("loggedUserUpdated", applyRouteAccess);
  }, []);

  useEffect(() => {
    const arrowvalue = false;
    const name:any = {};
    Routes.map((item) => {
      return (name[item.name] = arrowvalue);
    });
    setArrow(name);
  }, []);

  const handleEvent = (event:any) => {
    if (event.type === "mousedown") {
      setScrollActive(true);
    } else if (event.type === "mouseup") {
      setScrollActive("");
    }
  };

  const handleArrow = (item:any) => {
    const data = { ...arrow };
    const newObj:any = {};
    Object.keys(data).forEach((k:any) => {
      newObj[k] = k === item ? !data[k] : false;
    });
    setArrow(newObj);
  };

  return (
    <div className='container-fluid bg-[#EDF8F9]'>
    <LayoutStyled>
      <SideBar
        Routes={RouteAccess}
        sidebarState={sidebarMinimize}
        handleEvent={handleEvent}
        arrow={arrow}
        handleArrow={handleArrow}
        scrollActive={scrollActive}
        handleSidebarMinimize={() => setSidebarMinimize(!sidebarMinimize)}
      />
      <div className="Home-section">
        <Content
          sidebarState={sidebarMinimize}
          arrow={arrow}
          access={access}
        />
      </div>
    </LayoutStyled>
    <div className={`bg-[#E8EAEA] h-[32px] text-sm flex items-center justify-center rounded-lg mr-4 transition-all duration-300 ease-in-out ${sidebarMinimize ? 'ml-[6rem]' : 'ml-[16rem]'}`}>
        <div>
          <span className="mr-1 text-[#888888]">Contact us </span>
          <a href="mailto:contact@farallonmed.com" className="font-semibold text-primary-light">
            <span>contact@farallonmed.com</span>
          </a>
        </div>
    </div>
    </div>
  );
};

export default Layout;

